var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expansion-panels",
    { attrs: { disabled: _vm.checking } },
    [
      _c(
        "v-expansion-panel",
        { attrs: { id: "summary-mobile-accordion" } },
        [
          _c(
            "v-expansion-panel-header",
            {
              staticClass: "title-branding",
              on: {
                click: function($event) {
                  return _vm.goTo("summary")
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-start align-center" },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        color: _vm.$vuetify.theme.dark ? "" : "primary",
                        large: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n                    $mdiLegacyReviewSummary\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "h3",
                    {
                      class: _vm.$vuetify.theme.dark
                        ? "white--text"
                        : "primary--text"
                    },
                    [_vm._v("\n                    Summary\n                ")]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-expansion-panel-content",
            { staticClass: "no-padding-accordion-panel" },
            [
              _c(
                "v-card",
                { staticClass: "pa-0", attrs: { flat: "" } },
                [_c("summary-summary")],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-expansion-panel",
        { attrs: { id: "benefactor-mobile-accordion" } },
        [
          _c(
            "v-expansion-panel-header",
            {
              staticClass: "title-branding",
              on: {
                click: function($event) {
                  return _vm.goTo("benefactor")
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-start align-center" },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        color: _vm.$vuetify.theme.dark ? "" : "primary",
                        large: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n                    $mdiLegacyReviewBenefactor\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "h3",
                    {
                      class: _vm.$vuetify.theme.dark
                        ? "white--text"
                        : "primary--text"
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.getBenefactorLabel(_vm.client.benefactor_type)
                          ) +
                          " BeneFactor™\n                "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-expansion-panel-content",
            { staticClass: "no-padding-accordion-panel" },
            [
              _c(
                "v-card",
                { staticClass: "pa-0", attrs: { flat: "" } },
                [_c("summary-benefactor")],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-expansion-panel",
        { attrs: { id: "lpp-mobile-accordion" } },
        [
          _c(
            "v-expansion-panel-header",
            {
              staticClass: "title-branding",
              on: {
                click: function($event) {
                  return _vm.goTo("lpp")
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-start align-center" },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        color: _vm.$vuetify.theme.dark ? "" : "primary",
                        large: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n                    $mdiLegacyReviewLPP\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "h3",
                    {
                      class: _vm.$vuetify.theme.dark
                        ? "white--text"
                        : "primary--text"
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.getLppLabel(_vm.client.lpp_type)) +
                          " LPP™\n                "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-expansion-panel-content",
            { staticClass: "no-padding-accordion-panel" },
            [
              _c(
                "v-card",
                { staticClass: "pa-0", attrs: { flat: "" } },
                [_c("summary-lpp")],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-expansion-panel",
        { attrs: { id: "estate_and_trustee_fees-mobile-accordion" } },
        [
          _c(
            "v-expansion-panel-header",
            {
              staticClass: "title-branding",
              on: {
                click: function($event) {
                  return _vm.goTo("estate_and_trustee_fees")
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-start align-center" },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        color: _vm.$vuetify.theme.dark ? "" : "primary",
                        large: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n                    $mdiLegacyReviewEstate\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "h3",
                    {
                      class: _vm.$vuetify.theme.dark
                        ? "white--text"
                        : "primary--text"
                    },
                    [
                      _vm._v(
                        "\n\n                    Estate Fees " +
                          _vm._s(_vm.summaryShortFallText) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-expansion-panel-content",
            { staticClass: "no-padding-accordion-panel" },
            [
              _c(
                "v-card",
                { staticClass: "pa-0", attrs: { flat: "" } },
                [
                  _vm.client.value > 0
                    ? _c("summary-estate")
                    : _c("p", { staticClass: "mx-4" }, [
                        _vm._v(
                          "\n                    No information available\n                "
                        )
                      ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-expansion-panel",
        { attrs: { id: "mycover-mobile-accordion" } },
        [
          _c(
            "v-expansion-panel-header",
            {
              staticClass: "title-branding",
              on: {
                click: function($event) {
                  return _vm.goTo("mycover")
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-start align-center" },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        color: _vm.$vuetify.theme.dark ? "" : "primary",
                        large: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n                    $mdiLegacyReviewMyCover\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "h3",
                    {
                      class: _vm.$vuetify.theme.dark
                        ? "white--text"
                        : "primary--text"
                    },
                    [_vm._v("\n                    MyCover™\n                ")]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-expansion-panel-content",
            { staticClass: "no-padding-accordion-panel" },
            [
              _c(
                "v-card",
                { staticClass: "pa-0", attrs: { flat: "" } },
                [_c("summary-my-cover")],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.clientView
        ? _c(
            "v-expansion-panel",
            { attrs: { id: "advisor_wiifm-mobile-accordion" } },
            [
              _c(
                "v-expansion-panel-header",
                {
                  staticClass: "title-branding",
                  on: {
                    click: function($event) {
                      return _vm.goTo("advisor_wiifm")
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex justify-start align-center" },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            color: _vm.$vuetify.theme.dark ? "" : "primary",
                            large: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n                    $mdiLegacyReviewAdvisor\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "h3",
                        {
                          class: _vm.$vuetify.theme.dark
                            ? "white--text"
                            : "primary--text"
                        },
                        [
                          _vm._v(
                            "\n                    Advisor WIIFM\n                "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "v-expansion-panel-content",
                { staticClass: "no-padding-accordion-panel" },
                [
                  _c(
                    "v-card",
                    { staticClass: "pa-0", attrs: { flat: "" } },
                    [_c("summary-advisor")],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }